<section class="ip-table" *ngIf="data">

  <ng-content></ng-content>


  <ng-container *ngIf="!noTopOptions">
    <div class="ip-table__top">
      <div class="ip-table__top--fn_inputs" *ngIf="!billed && optionalTitle">
        <div>
        <span class="ip-table__top--fn_inputs_title">{{
            optionalTitle | translate
          }}</span>
        </div>

        <div
          class="ip-table__top--fn_inputs__mobile-filters"
          *ngIf="this.service !== 'supplier-accounts'"
        >
          <button (click)="openFiltersModal()">
          <span class="ip-table__top--fn_inputs__mobile-filters__span"
          >Filtrar</span
          >
            <img
              src="../../../../assets/new-styles/icons/buttons/filters-icon.svg"
              alt=""
            />
          </button>
        </div>

        <div class="ip-table__top--fn_inputs-filters">
          <form
            [formGroup]="datesForm"
            class="ip-table__top--fn_inputs-filters_dates-form"
            *ngIf="this.service !== 'supplier-accounts'"
          >
            <div class="ip-table__top--fn_inputs-filters_dates">
            </div>
            <div class="ip-table__top--fn_inputs-filters_dates">
              <app-ip-date-input
                [control]="creationDateControl"
                inputId="createDateFrom"
                (changed)="onStartDateChange()"
                [max]="maxDate"
                [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.FROM' | translate"
                #startDateInput></app-ip-date-input>
            </div>
            <div class="ip-table__top--fn_inputs-filters_dates">
              <app-ip-date-input
                [control]="dueDateControl"
                inputId="createDateTo"
                (changed)="onEndDateChange()"
                [min]="minEndDate"
                [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.TO' | translate"
                #dueDateInput></app-ip-date-input>
            </div>
          </form>
          <div class="ip-table__top--fn_inputs-filters_search" *ngIf="searchField">
            <app-ip-search-input
              #searchInput
              [hidePrefix]="true"
              [placeholder]="'Buscar'"
              (onSearch)="this.onSearch($event)"
            ></app-ip-search-input>
            <button
              class="ip-table__top--fn_inputs-filters_search-btn"
              (click)="executeService(searchInput.searchValue)"
              *ngIf="this.service !== 'supplier-accounts'"
            >
              <img
                src="../../../../assets/new-styles/icons/buttons/search-icon-white.svg"
                alt=""
              />
            </button>
          </div>
          <div class="ip-table__top--fn_inputs-filters_search" *ngIf="!searchField">
            <app-ip-button-modal
              typeBtn="action2"
              (clicked)="executeService()"
              [matTooltip]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.SEARCH' | translate"
              matTooltipPosition="above"
              [size]="'small'"
              [disabled]="creationDate?.value === '' || dueDate?.value === '' || creationDate?.value > dueDate?.value"
              *ngIf="this.service !== 'supplier-accounts'"
            >
              <img
                class="ip-table__top--fn_inputs-filters-icon"
                src="assets/img/ip-table-dashboard/search.svg"
              />
            </app-ip-button-modal>
          </div>
        </div>
      </div>
      <div class="ip-table__top-option" *ngIf="!billed && !optionalTitle && !noTopOptions">
        <ng-container *ngIf="service !== 'invoice-paid'">
          <app-ip-select-input
            (selectEmitter)="onSelectionChange($event)"
            [control]="selectFormControl"
            [label]="'IP.TABLE.INVOICES.FILTER_STATUS' | translate">
            >
            <option
              *ngFor="let select of tableOption.selects; let i = index"
              [value]="i"
            >
              {{ select[0] | translate }}
            </option>
          </app-ip-select-input>
        </ng-container>
        <div
          class="ip-table__top-option-search{{ tableTitle ? '' : '' }}"
          *ngIf="
          service !== 'subsidiaries' &&
          service !== 'user-management' &&
          service !== 'admin-management' &&
          service !== 'employee-management' &&
          service !== 'supplier-users'
        "
        >
          <div
            class="ip-table__top-option-search{{
            tableTitle ? '' : ''
          }}-input"
          >
            <span
              class="ip-table__top-option-search-filter"
              *ngIf="filter"
              [style.background-image]="
              'url(assets/img/ip-table-dashboard/filter.svg)'
            "
              (click)="toggleFilter(true)"
            ></span>
            <div
              class="ip-table__top-option-search-filters"
              *ngIf="filter && showFilter && mode === 'side'"
            >
              <app-ip-filters
                [service]="service"
                (close)="toggleFilter(false)"
                [filters]="tableOption.filters || []"
                [filterValues]="this.filterValues"
                (applyFilters)="setFilters($event)"
                [onlyLast30days]="this.onlyLast30days"
              >
                ></app-ip-filters
              >
            </div>
            <app-ip-modal-mobile [showTitle]="false" [showCloseModal]="false" *ngIf="filter && showFilter && mode === 'over'">
              <app-ip-filters
                [service]="service"
                (close)="toggleFilter(false)"
                [filters]="tableOption.filters || []"
                [filterValues]="this.filterValues"
                (applyFilters)="setFilters($event)"
                [onlyLast30days]="this.onlyLast30days"
              >
                ></app-ip-filters
              >
            </app-ip-modal-mobile>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="ip-table__table-searchbox"
    *ngIf="this.service === 'supplier-accounts'"
  >
    <app-fn-search-input
      *ngIf="this.service === 'supplier-accounts'"
      (onSearch)="this.onSearch($event)"
    >
    </app-fn-search-input>
  </div>

  <div class="ip-table__table" *ngIf="data.length">
    <app-table
      *ngIf="data.length && mode === 'side'"
      class="ip-table__table--desktop"
      [data]="data"
      [keyTranslate]="tableOption.keyTranslate"
      [actions]="tableOption.actions"
      tableStyle="invopay"
      (sort)="onSortTable($event)"
      (action)="onActionTable($event)"
      [propertyOrder]="propertyOrder"
      [scroll]="scroll"
    ></app-table>
    <!-- <app-card-table
      *ngIf="data.length && mode === 'over'"
      class="ip-table__table--mobile"
      [dataCard]="data"
      [service]="this.service"
      [actions]="tableOption.actions"
      [keyTranslate]="tableOption.keyTranslate"
      (action)="onActionTable($event)"
    >
    </app-card-table> -->
    <app-paginator
    *ngIf="data && totalItems > pageItems"
    [currentPages]="currentPage + 1"
    [itemsPerPage]="pageItems"
    [totalItems]="totalItems"
    (pageChange)="onPageChange($event)"
    ></app-paginator>
  </div>
  <app-mobile-card-list
    *ngIf="mode === 'over'"
    [data]="data"
    [config]="mobileCardConfig"
    [showNoData]="!data || data.length === 0"
    (action)="onActionTable($event)">
  </app-mobile-card-list>
  <div *ngIf="data">
    <app-no-data *ngIf="!data.length && mode === 'side'" [service]="service"></app-no-data>
  </div>
</section>
